export class HostParts {
  subdomain: string;
  domain: string;
}
